import PDMHome from "@tw/product-discovery-merchandizing-cra/lib/home/home-master-nextjs";
import PageWrapper from "../wrappers/page-wrapper";

PDMHome.domainName = "product-discovery";
PDMHome.pageId = "HP";

export default PageWrapper(PDMHome);
